export default __webpack_public_path__ + "static/media/Icon.19f0df10.png";